import { PaletteOptions } from '@mui/material';

export const paletteEscuro: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#2A51F7', // Azul principal tecnológico
    light: '#5E7BFF',
    dark: '#102EB3',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#6366F1', // Indigo complementar
    light: '#818CF8',
    dark: '#4F46E5',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#10B981', // Verde operacional saudável
    light: '#34D399',
    dark: '#059669',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#F59E0B', // Amarelo de atenção
    light: '#FBBF24',
    dark: '#D97706',
    contrastText: '#1E293B',
  },
  error: {
    main: '#EF4444', // Vermelho para falha/crítico
    light: '#F87171',
    dark: '#DC2626',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#0A0E1A', // Fundo principal escuro premium
    paper: '#111827',   // Fundo secundário (cards/menus)
  },
  text: {
    primary: '#F8FAFC',   // Texto principal brilhante
    secondary: '#94A3B8', // Texto secundário suave
    disabled: '#64748B',
  },
  divider: '#1E293B',     // Divisórias discretas
};

export const paletteClaro: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#2A51F7', // Mesmo azul principal tecnológico
    light: '#5E7BFF',
    dark: '#102EB3',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#6366F1',
    light: '#818CF8',
    dark: '#4F46E5',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#10B981',
    light: '#34D399',
    dark: '#059669',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#F59E0B',
    light: '#FBBF24',
    dark: '#D97706',
    contrastText: '#1E293B',
  },
  error: {
    main: '#EF4444',
    light: '#F87171',
    dark: '#DC2626',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F8FAFC', // Fundo principal cinza claro
    paper: '#FFFFFF',   // Fundo secundário (cards/menus) branco
  },
  text: {
    primary: '#0F172A',   // Texto principal escuro (slate 900)
    secondary: '#475569', // Texto secundário suave (slate 600)
    disabled: '#94A3B8',
  },
  divider: '#E2E8F0',     // Divisórias cinzas claras
};
